import React from 'react';
import { Box, Dropdown, Loader, Text } from 'braid-design-system';
import { useGetHirerAccountsQuery } from './GetHirerAccounts.generated';

export const AccountSelector = () => {
  const handleAccountSelection: React.FormEventHandler<HTMLSelectElement> = (
    e,
  ) => {
    window.location.assign(e.currentTarget.value);
  };

  const { loading, data, error } = useGetHirerAccountsQuery({
    variables: {
      returnUri:
        new URLSearchParams(window.location.search).get('returnUrl') ?? '/',
    },
  });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <Text>Error fetching accounts</Text>;
  }

  const allAccounts = data?.hirerAccounts.edges.map(({ node }) => node) ?? [];
  const filteredAccounts = allAccounts.filter(
    ({ hasConnectedTalentSearchAccess }) => hasConnectedTalentSearchAccess,
  );

  if (filteredAccounts.length === 1) {
    const account = filteredAccounts[0];
    window.location.assign(account.loginRedirectUrl);

    return null;
  }

  return (
    <Box data-widget-id="accountSelector" display="flex">
      <Dropdown
        aria-label="Select an account"
        id="tsc-account-selector"
        placeholder="Select an account"
        value=""
        onChange={handleAccountSelection}
      >
        {filteredAccounts.map((tscAccount) => (
          <option key={tscAccount.id} value={tscAccount.loginRedirectUrl}>
            {`${tscAccount.businessName} (${tscAccount.id})`}
          </option>
        ))}
      </Dropdown>
    </Box>
  );
};
